import React, { FC, HTMLAttributes, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { IconButtonColorType, iconButtonBorderRadiusesRem, iconButtonIconColorByColor, iconButtonIconSizesRem, iconButtonPaddingsRem, iconButtonSizesRem, iconButtonSpinnerSizesRem } from '@shared/config/components/iconButton';
import { Spinner } from '@shared/ui/atoms';
import { withTheme } from '@shared/lib/theme';
type SizeValue = keyof typeof iconButtonIconSizesRem;
type ResponsiveSize = SizeValue | {
  mobile: SizeValue;
  desktop: SizeValue;
};
interface IconButtonProps extends Omit<HTMLAttributes<HTMLButtonElement>, 'color'> {
  disabled?: boolean;
  isLoading?: boolean;
  withHoverShadow?: boolean;
  size?: ResponsiveSize;
  color?: IconButtonColorType;
  icon?: ReactNode;
  onClick?: () => void;
}
const IconButton: FC<IconButtonProps> = ({
  size = '52',
  color = 'accent',
  isLoading = false,
  disabled = false,
  withHoverShadow = false,
  icon,
  onClick,
  ...rest
}) => {
  const desktopSize = typeof size === 'object' ? size.desktop || '52' : size || '52';
  const mobileSize = typeof size === 'object' ? size.mobile || desktopSize : size || '52';
  return <IconButtonWrapper desktopSize={desktopSize} mobileSize={mobileSize} color={color} isLoading={isLoading} disabled={disabled} withHoverShadow={withHoverShadow} onClick={onClick} {...rest}>
      {isLoading ? <SpinnerWrapper desktopSize={desktopSize} mobileSize={mobileSize}>
          <Spinner />
        </SpinnerWrapper> : <>
          {icon && <IconWrapper desktopSize={desktopSize} mobileSize={mobileSize}>
              {icon}
            </IconWrapper>}
        </>}
    </IconButtonWrapper>;
};
export default IconButton;
type IconButtonWrapperProps = Required<Pick<IconButtonProps, 'isLoading' | 'withHoverShadow' | 'color'>> & {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp2 = /*#__PURE__*/() => ({
  desktopSize
}) => iconButtonSizesRem[desktopSize];
const _exp3 = /*#__PURE__*/() => ({
  desktopSize
}) => iconButtonPaddingsRem[desktopSize];
const _exp4 = /*#__PURE__*/() => ({
  desktopSize
}) => iconButtonBorderRadiusesRem[desktopSize];
const _exp5 = /*#__PURE__*/() => ({
  disabled,
  color,
  theme
}) => disabled ? theme.colors.background.disabled : theme.colors.background[color];
const _exp6 = /*#__PURE__*/() => ({
  disabled,
  color,
  theme
}) => disabled ? theme.colors.icon.disabled : theme.colors.icon[iconButtonIconColorByColor(color)];
const _exp7 = /*#__PURE__*/() => ({
  disabled
}) => disabled ? 'default' : 'pointer';
const _exp8 = /*#__PURE__*/() => ({
  disabled,
  isLoading
}) => disabled || isLoading ? 'none' : 'default';
const _exp9 = /*#__PURE__*/() => ({
  withHoverShadow,
  theme
}) => withHoverShadow ? `0px 0px 2.5rem 1.125rem ${theme.colors.background.accent_30}` : `inset 0 0 0 9999px ${theme.colors.background.hover}`;
const _exp0 = /*#__PURE__*/() => ({
  withHoverShadow,
  theme
}) => withHoverShadow ? `0px 0px 2.5rem 1.125rem ${theme.colors.background.accent_30}` : `inset 0 0 0 9999px ${theme.colors.background.hover}`;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "iac9cxs",
  propsAsIs: false,
  vars: {
    "iac9cxs-0": [_exp2()],
    "iac9cxs-1": [_exp3()],
    "iac9cxs-2": [_exp4()],
    "iac9cxs-3": [_exp5()],
    "iac9cxs-4": [_exp6()],
    "iac9cxs-5": [_exp7()],
    "iac9cxs-6": [_exp8()],
    "iac9cxs-7": [_exp9()],
    "iac9cxs-8": [_exp0()]
  }
}));
type IconWrapperPropsType = {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp1 = /*#__PURE__*/() => ({
  desktopSize
}) => iconButtonIconSizesRem[desktopSize];
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "iuqsq5k",
  propsAsIs: false,
  vars: {
    "iuqsq5k-0": [_exp1()]
  }
});
type SpinnerWrapperPropsType = {
  desktopSize: SizeValue;
  mobileSize: SizeValue;
};
const _exp10 = /*#__PURE__*/() => ({
  desktopSize
}) => iconButtonSpinnerSizesRem[desktopSize];
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "s9g5l6m",
  propsAsIs: false,
  vars: {
    "s9g5l6m-0": [_exp10()]
  }
});

require("./IconButton.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./IconButton.tsx");